import React from 'react';

import { Box, FormField, Label, TextButton } from '@zillow/constellation-10';

import type { Section } from '../../../../models';
import YesAndNo from '../../../Widgets/YesAndNo';
import { ONE_HUNDRED_YEAR_FLOODPLAIN } from '../../../../constants';
import InlineTooltip from '../../../Widgets/InlineTooltip';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

export default function OneHundredYearFloodplain({ section, setSectionValues }: Props): JSX.Element {
  function onYesFloodplainClick(): void {
    setSectionValues({
      [ONE_HUNDRED_YEAR_FLOODPLAIN.FIELD_NAME.LOCATED_IN_100_YEAR_FLOODPLAIN]: true,
    });
  }

  function onNoFloodplainClick(): void {
    setSectionValues({
      [ONE_HUNDRED_YEAR_FLOODPLAIN.FIELD_NAME.LOCATED_IN_100_YEAR_FLOODPLAIN]: false,
    });
  }

  return (
    <>
      <FormField
        required
        label={
          <Label>
            Is the property located in a{' '}
            <InlineTooltip
              tooltipBodyText={
                <>
                  A 100-year floodplain has a 1% chance of flooding in any given year.
                  <Box css={{ display: 'flex', marginTop: 'layout.tighter' }}>
                    <TextButton asChild>
                      <a target="_blank" rel="noopener noreferrer" href="https://www.fema.gov/flood-zones">
                        Learn more
                      </a>
                    </TextButton>
                  </Box>
                </>
              }
              closeWith={['blur']}
              openWith={['focus', 'click', 'mouseEnter']}
              shouldCloseOnOutsideClick
            >
              100-year floodplain
            </InlineTooltip>
            ?
          </Label>
        }
        control={
          <YesAndNo
            noHandler={onNoFloodplainClick}
            yesHandler={onYesFloodplainClick}
            yesActive={section.getFieldValue(ONE_HUNDRED_YEAR_FLOODPLAIN.FIELD_NAME.LOCATED_IN_100_YEAR_FLOODPLAIN)}
          />
        }
      />
    </>
  );
}

OneHundredYearFloodplain.description = 'Oregon specific flooding screen';
